<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import SendNotificationChoiceModal from "~/components/Pages/training-plan/session-details/notifications/SendNotificationChoiceModal.vue";
import { useSessions } from "~/composables/sessions/useSessions";
import { useNotificationsStore } from "~/store/notifications/notifications.store";
import { ActionTypeEnum } from "~/utils/enums/notifications.enums";
import type { SessionNotificationDeliveryEnum } from "~/utils/enums/session-notifications.enums";
import { isAttendeesDeliveryChoice } from "~/utils/helpers/session-notifications/delivery-choice";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["handleLater", "openConfigNotif"]);
const props = defineProps(["users", "isPlanningInProgress"]);

const notificationStore = useNotificationsStore();
const { createSession } = storeToRefs(notificationStore);
const sessions = useSessions();
const showDeliveryChoice = ref(false);

function handleLater() {
  emit("handleLater");
}

function openConfigNotif(choice: SessionNotificationDeliveryEnum) {
  if (!isAttendeesDeliveryChoice(choice)) return;
  createSession.value.metadata.sendIcs = true;
  // Without `users`, the recipients are the list SessionAddAttendeeModal handed over before opening this prompt.
  sessions.notifyDelivery(
    choice,
    props.users?.length ? props.users : (createSession.value.attendees ?? []),
    ActionTypeEnum.SUMMON,
  );

  emit("openConfigNotif");
}
</script>

<template>
  <!-- Who to convoke, asked after « Convoquer » as on the session's other sends; closing it is « Plus tard ». -->
  <SendNotificationChoiceModal
    v-if="showDeliveryChoice"
    :show-session-recipients="false"
    @hide="handleLater"
    @choose="openConfigNotif"
  />
  <CenterModal v-else :style="{ 'max-width': '488px', width: '100%' }">
    <template #body>
      <div class="p-[24px] flex flex-col gap-6">
        <h4 v-if="isPlanningInProgress" class="heading_3_demi">
          Voulez-vous convoquer dès maintenant les participants ?
        </h4>
        <h4 v-else class="heading_3_demi">Cette session a déjà été convoquée</h4>
        <p v-if="isPlanningInProgress" class="body_regular text-secondary-color">
          Vous pourrez valider à la prochaine étape le contenu du mail avant envoi.
        </p>
        <p v-else class="body_regular text-secondary-color">
          Les convocations pour cette session ont déjà été envoyées. Souhaitez-vous convoquer ce(s) participant(s)
          maintenant ?
        </p>

        <div class="flex justify-center gap-[16px]">
          <AppButton type="outlined" label="Plus tard" class="w-full" @click="handleLater" />
          <AppButton label="Convoquer" class="w-full" @click="showDeliveryChoice = true" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
